import { Field, Select } from "./common";
import { useAuth } from "../lib/auth";
import { useI18n } from "../lib/i18n";

// GKK + Unit picker limited to what the signed-in user may use.
export default function ScopePicker({ gkk, unit, onChange, allowAll = false, forWrite = false, testid = "scope" }) {
  const { meta, user } = useAuth();
  const { t } = useI18n();
  const gkks = (meta?.gkks || []).filter((g) => !forWrite || g.status !== "Archived");
  const units = (meta?.units || []).filter((u) => u.gkk_id === gkk && (!forWrite || u.active));
  const lockUnit = forWrite && user?.role === "unit_treasurer";
  return (
    <div className="grid sm:grid-cols-2 gap-4">
      <Field label={t("gkk")}>
        <Select data-testid={`${testid}-gkk-select`} value={gkk || ""} onChange={(e) => onChange(e.target.value, "")} disabled={gkks.length === 1 && !allowAll}>
          {allowAll ? <option value="">All GKKs (Parish-wide)</option> : <option value="">— Choose GKK —</option>}
          {gkks.map((g) => <option key={g.id} value={g.id}>{g.name}</option>)}
        </Select>
      </Field>
      <Field label={t("unit")}>
        <Select data-testid={`${testid}-unit-select`} value={unit || ""} onChange={(e) => onChange(gkk, e.target.value)} disabled={!gkk || lockUnit}>
          <option value="">{allowAll ? "All Units (consolidated)" : t("gkk_level")}</option>
          {units.map((u) => <option key={u.id} value={u.id}>{u.name}</option>)}
        </Select>
      </Field>
    </div>
  );
}
